import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ReactComponent as Filter } from "../../assets/images/icons/filter.svg";
import { ReactComponent as Close } from "../../assets/images/icons/close.svg";
import { getAllTags } from "../../redux/productTags/productTagActions";

export function FilterStoreModal({ 
  categories = [], 
  setFilterCount = () => {}, 
  handleFilter = () => {}, 
  onClear = () => {} 
}) {
  const dispatch = useDispatch();
  let [isOpen, setIsOpen] = useState(false);
  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }
  const [tags, setTags] = useState([]);
  const [tagsArr, setTagsArr] = useState([]);
  const [categoryArr, setCategoryArr] = useState([]);
  const [data, setData] = useState({
    store_categories: [],
    store_tags: [],
  });
  const { store_categories, store_tags } = data;
  const { allTags } = useSelector((state) => state.productTag);
  useEffect(() => {
    dispatch(getAllTags());
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    let items = allTags?.data?.filter((item) => item.type === "store");
    setTags(items);
  }, [allTags]);

  const handleTags = (tag, i) => {
    // Check if the same tag is clicked again (deselect)
    if (tagsArr.includes(i)) {
      setData({
        ...data,
        store_tags: [],
      });
      setTagsArr([]);
    } else {
      // Select only this tag (replace any previous selection)
      setData({
        ...data,
        store_tags: [tag.name],
      });
      setTagsArr([i]);
    }
  };

  const handleCategories = (category, i) => {
    // Check if the same category is clicked again (deselect)
    if (categoryArr.includes(i)) {
      setData({
        ...data,
        store_categories: [],
      });
      setCategoryArr([]);
    } else {
      // Select only this category (replace any previous selection)
      setData({
        ...data,
        store_categories: [category.name],
      });
      setCategoryArr([i]);
    }
  };

  const handleClear = () => {
    setData({
      ...data,
      store_tags: [],
      store_categories: [],
    });
    setTagsArr([]);
    setCategoryArr([]);
    setFilterCount(0);
    // Call onClear callback if provided to reload original data
    if (onClear) {
      onClear();
    }
    closeModal();
  };

  return (
    <div data-test="filterModal">
      <Filter className=" cursor-pointer  h-6 w-6" onClick={openModal} />
      <Transition show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[600px] bg-white dark:bg-[#121212] rounded-3xl px-4 pt-5 pb-4  overflow-hidden shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full  sm:p-8">
                  <div className=" sm:block absolute top-1 sm:top-3 right-5 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-[#ffeae5] dark:bg-[#CE2600] rounded-md sm:p-3 p-2"
                      onClick={closeModal}
                    >
                      <span className="sr-only">Close</span>
                      <Close className="w-3 h-3 sm:w-4 sm:h-4 white-icon" />
                    </button>
                  </div>
                  <div>
                    <div className=" text-center sm:mt-6 sm:text-center">
                      <Dialog.Title
                        as="h3"
                        className="text-xl mb-4 font-bold text-black dark:text-white"
                      >
                        Filter
                      </Dialog.Title>
                    </div>
                  </div>{" "}
                  <div>
                    <div className="border-b-2"></div>
                    <h3 className="text-lg font-medium text-left sm:text-left mt-6 ">
                      Sort by Tags
                    </h3>

                    <div className="flex flex-wrap gap-3 mt-3">
                      {tags?.length > 0 &&
                        tags.map((tag, i) => (
                          <button
                            key={i}
                            className={`${
                              tagsArr?.includes(i)
                                ? "bg-primary text-white"
                                : "bg-[#F6F3F3] text-[#4D4C4C]"
                            }  rounded-md px-2 py-2 text-center text-sm cursor-pointer`}
                            onClick={() => handleTags(tag, i)}
                          >
                            {tag?.name}
                          </button>
                        ))}
                    </div>

                    {categories?.length > 0 && (
                      <h3 className=" text-lg font-medium px-4 text-left sm:text-left mt-12 ">
                        Sort by Categories
                      </h3>
                    )}
                    <div className="flex flex-wrap gap-3 mt-3">
                      {categories?.length > 0 &&
                        categories?.map((category, i) => (
                          <button
                            key={i}
                            className={`${
                              categoryArr?.includes(i)
                                ? "bg-primary text-white"
                                : "bg-[#F6F3F3] text-[#4D4C4C]"
                            } rounded-md px-2 py-2 text-center text-sm cursor-pointer`}
                            onClick={() => handleCategories(category, i)}
                          >
                            {category?.name}
                          </button>
                        ))}
                    </div>

                    <div className="flex justify-between mt-32">
                      <button
                        className="bg-white text-primary w-48 h-12 sm:w-60 sm:mr-4 border border-primary rounded-lg"
                        type="button"
                        onClick={handleClear}
                      >
                        Clear All
                      </button>
                      <button
                        className="bg-primary text-white w-48 h-12 sm:w-60 rounded-lg "
                        type="button"
                        // onClick={() => props.onClick(data)}
                        onClick={() => {
                          setFilterCount(
                            store_tags?.length + store_categories?.length
                          );
                          handleFilter(data);
                          closeModal();
                        }}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
